module.exports = __webpack_public_path__ + "aj.no1.c55fc514.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/aj.no1.jpg
// module id = isff
// module chunks = 0